$(document).ready(function () { 
  
      if($('.img_text_slide_random').length>0){ 
        // Step 1: Randomize slides
        const $slider = $('.img_text_slide_random');
        const $slides = $slider.find('.slideshow__slide.slide_show_inner');
      /*
        if ($slides.length) {
          const shuffledSlides = $slides.sort(function () {
            return 0.5 - Math.random();
          });
      
          $slider.trigger('destroy.owl.carousel'); // Just in case it's already initialized
          $slider.empty(); // Remove existing slides
      
          // Append shuffled slides
          shuffledSlides.each(function () {
            $slider.append($(this));
          });
        }
      */
        // Step 2: Initialize Owl Carousel
        const randSlider = $slider.owlCarousel({
          items: 1,
          loop: true,
          autoplay: true,
          animateOut: 'fadeOut',
          nav: false,
          dots: false,
          onInitialized: updateSlideInfo,
          onChanged: updateSlideInfo
        });
      
        // Step 3: Cache navigation and counter elements
      
        // Step 4: Update counters and button states
        function updateSlideInfo(event) {
          
              let rend_current_index = $('.image_with_text_slideshow .slider-counter--current');
              let rend_total_index = $('.image_with_text_slideshow .slider-counter--total'); 
          let currentIndex = event.item.index + 1;
          const totalItems = event.item.count;
          if(currentIndex > totalItems ){
            currentIndex = Number(currentIndex) - Number(totalItems);
          }
          rend_current_index.text(currentIndex);
          rend_total_index.text(totalItems);
       
        }
      
       
    }



  
    var $stickyElement = $('.template-collection #ProductGridContainer');

    if ($stickyElement.length) { // Check if stickyElement exists
      var $itemToSticky = $('.template-collection #main-collection-filters');
      var stickyElementOffset = $stickyElement.offset().top - 50;

      function handleScroll() {
          var scrollPosition = $(window).scrollTop();
          var $headerSticky = $('.shopify-section-header-sticky');

          if (scrollPosition >= stickyElementOffset) {
              if (!$headerSticky.hasClass('shopify-section-header-hidden')) {
                  $itemToSticky.addClass('sticky_top');
              } else {
                  $itemToSticky.removeClass('sticky_top');
              }
          } else {
              $itemToSticky.removeClass('sticky_top');
          }
      }

      $(window).on('scroll', handleScroll); // Call handleScroll when user scrolls
    }

    var $stickyElement2 = $('.sticky_tab_area');

    if ($stickyElement2.length) { // Check if stickyElement exists
      var $itemToSticky2 = $('.sticky_tab_area');
      var stickyElement2Offset = $stickyElement2.offset().top - 50;

      function handleScroll() {
          var scrollPosition = $(window).scrollTop();
          var $headerSticky = $('.shopify-section-header-sticky');

          if (scrollPosition >= stickyElement2Offset) {
              if (!$headerSticky.hasClass('shopify-section-header-hidden')) {
                  $itemToSticky2.addClass('sticky_top');
              } else {
                  $itemToSticky2.removeClass('sticky_top');
              }
          } else {
              $itemToSticky2.removeClass('sticky_top');
          }
      }

      $(window).on('scroll', handleScroll); // Call handleScroll when user scrolls
    }
});


$(document).ready(function(){
  $('.pickyou_Banners').each(function() {
    var desktopColumns = $(this).attr('desktop-column-count');
    var mobileColumns =  $(this).attr('mobile-column-count');
    var slideCenter =  $(this).attr('slide-center');
    desktopColumns = desktopColumns ? parseFloat(desktopColumns) : 1.5;
    mobileColumns = mobileColumns ? parseFloat(mobileColumns) : 1;

    $(this).addClass('owl-carousel');

    $(this).owlCarousel({
          center: true,
          items: mobileColumns,
          nav: true,
          dots: true,
          loop: true,
          margin: 10,
          responsive: {
              600: {
                  items: desktopColumns,
                  center: slideCenter
              }
          }
      });
    console.log('desktop - ' + (desktopColumns * 5));
    console.log('mobile - ' + (mobileColumns * 5));
  });



        var cards_container = $(".rondom_grid");
        var cards = $(".rondom_grid .collection-list .collection-list__item");
        var $cardsBox = $(".rondom_grid .collection-list");

        if(cards.length > 2){
                  for(var i = 0; i < cards.length; i++){
                      var target = Math.floor(Math.random() * cards.length -1) + 1;
                      var target2 = Math.floor(Math.random() * cards.length -1) +1;

                    //console.log(`${target} and ${target2}`);

                      cards.eq(target).before(cards.eq(target2));
                  }
            var randcards = $(".rondom_grid .collection-list .collection-list__item");

            $cardsBox.empty();



            var itemsPerCard = 50;
            //var remainingItems = randcards.length % itemsPerCard;
            var numCards = cards_container.length;


            for (var i = 0; i < numCards; i++) {
              var startIndex = i * itemsPerCard;
              var endIndex = startIndex + itemsPerCard;
              var cardItems = randcards.slice(startIndex, endIndex);
              cards_container.eq(i).find(".collection-list").html(cardItems);

              //console.log(`${startIndex} to ${endIndex}`);
            }
        }



      $(document).on('dragend mouseup touchend','.price_slider_container', function() {
        $(this).trigger('click');
      });


    $(document).on('click', 'facet-remove a', function() {
        const urlParams = new URLSearchParams($(this).attr('href')); // Create a URLSearchParams object from the href attribute
        if (urlParams.has('filter.v.availability')) {
            $('#inventoryFilterDesktop').prop('checked', true);
        } else {
            $('#inventoryFilterDesktop').prop('checked', false);
        }
    });
});

var ListOrderManager = {
  applyRandomOrder: function() {
    var lists = document.querySelectorAll('.random_order ul.collection-list');

    if (lists.length > 0) {
      lists.forEach(function(list) {
        var listItems = list.querySelectorAll('li');
        var totalItems = listItems.length;

        // Generate an array of numbers from 0 to (totalItems - 1)
        var orderArray = Array.from(Array(totalItems).keys());

        // Shuffle the array to randomize the order
        for (let i = orderArray.length - 1; i > 0; i--) {
          let j = Math.floor(Math.random() * (i + 1));
          [orderArray[i], orderArray[j]] = [orderArray[j], orderArray[i]];
        }

        // Apply the shuffled order to the list items
        listItems.forEach(function(item, index) {
          item.style.order = orderArray[index]; // Assign unique random order
          //console.log('Added order:', orderArray[index]);
        });
      });
    }
  }
};

document.addEventListener('DOMContentLoaded', function() {
   ListOrderManager.applyRandomOrder();
});





// image change rendom

const HoverEffectManager = {
    hoverEffects: document.querySelectorAll(".collection-301771358357 .media--hover-effect"),
    duration: 3000, // 2 seconds for class to be applied and removed
    delay: 100, // 100 ms stagger between items
    batchSize: 10, // Reset every 10 items
    intervalId: null,

    applyHoverEffect() {
        this.hoverEffects.forEach((element, index) => {
            setTimeout(() => {
                this.toggleHoverEffect(element); // Start toggle effect for each element
            }, (index % this.batchSize) * this.delay); // Staggered delay for each element
        });
    },

    toggleHoverEffect(element) {
        // Create a repeating effect for each element
        setInterval(() => {
            element.classList.add("apply_hover");
            setTimeout(() => {
                element.classList.remove("apply_hover");
            }, this.duration); // Remove class after 2 seconds
        }, this.duration * 2); // Repeat every 4 seconds (2 seconds add + 2 seconds remove)
    },

    start() {
        if (this.hoverEffects.length === 0) return; // Only start if elements are found
        this.applyHoverEffect(); // Start the effect immediately
    },

    stop() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    },

    init() {
        if (!this.initialized) { // Ensure initialization happens only once
            window.addEventListener("load", () => this.start()); // Start after page fully loads
            this.initialized = true;
        }
    }
};

// Initialize the hover effect manager
// HoverEffectManager.init();





$(document).ready(function () {
    const autoplayTimeout = 5000;  

    const slider = $('.image_with_text_slide').owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: autoplayTimeout,
        animateOut: 'fadeOut',
        nav: false,
        dots: true,
        onChanged: function (event) {
            if ($(event.target).find('.owl-dot').length > 0) {
                updatePrevNextClasses(event); // Call the function if dots exist
            }
        }
    });

    function updatePrevNextClasses(event) {
        const $dots = $(event.target).find('.owl-dot'); // All dots
        const activeIndex = event.item.index - event.relatedTarget._clones.length / 2; // Adjust for clones
        const totalItems = event.item.count; // Total number of items

        // Normalize the index for looping
        const normalizedIndex = (activeIndex + totalItems) % totalItems;

        // Remove previous 'prev-dot' and 'next-dot' classes from all dots
        $dots.removeClass('prev-dot next-dot');

        // Add 'prev-dot' and 'next-dot' classes
        $dots.each(function (index) {
            if (index < normalizedIndex) {
                $(this).addClass('prev-dot');
            } else if (index > normalizedIndex) {
                $(this).addClass('next-dot');
            }
        });

        // Ensure the active dot itself does not have 'prev-dot' or 'next-dot'
        $dots.eq(normalizedIndex).removeClass('prev-dot next-dot');

        // Handle wrap-around for looping carousels
        if (normalizedIndex === 0 && totalItems > 1) {
            $dots.last().addClass('prev-dot');
        }
        if (normalizedIndex === totalItems - 1 && totalItems > 1) {
            $dots.first().addClass('next-dot');
        }
    }
});








// Check if `.banner_slider` exists

$(document).ready(function () {
  

  
  if ($('.slideshow_new.swiper-container').length > 0) {  
     let isWaitingForSecondScroll = 0;
      const swiper = new Swiper('.slideshow_new.swiper-container', {
        direction: 'vertical',
        loop: false,
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: false,
        mousewheel: {
          forceToAxis: true, 
          releaseOnEdges: true
        },
        touchReleaseOnEdges: true, // Try this instead
      });

 
  }
  
  if ($('.banner_slider.owl-carousel').length > 0) {
    $('.banner_slider.owl-carousel').each(function () {
      const $slider = $(this);

      // Get data attributes
      const bannerCount = parseInt($slider.data('banner-count')) || 0;
      const productCount = parseInt($slider.data('product-count')) || 0;
      const collectionCount = parseInt($slider.data('collection-count')) || 0;
      const itemCenter = Boolean(Number($slider.data('slide-center')) || 0); 
      const itemLoop = Boolean(Number($slider.data('slide-loop')) || 0); 
      const itemsDesktop = parseInt($slider.data('columns-desktop')) || 3;
      const itemsTablet = parseInt($slider.data('columns-tablet')) || 2;
      const itemsMobile = parseInt($slider.data('columns-mobile')) || 1; 
      const autoplayTimeout = parseInt($slider.data('autoplay-timeout')) || 3000;
 
      // Determine itemsToShow based on block types
      let itemsToShow = 1; // Default
      if (bannerCount > 0) {
        itemsToShow = 1; // Full width for banners
      } else if (productCount > 0) {
        itemsToShow = Math.max(itemsDesktop, itemsTablet, itemsMobile); // Use responsive settings
      } else if (collectionCount > 0) {
        itemsToShow = 2; // Default to 2 items for collections
      }

      // Initialize Owl Carousel
      $slider.owlCarousel({
        loop: itemLoop,
        margin: 10,
        nav: false,
        dot: false,
        autoplay: false,
        center: itemCenter, 
        autoplayTimeout: autoplayTimeout,
        responsive: {
          0: { items: itemsMobile },
          600: { items: itemsTablet },
          1000: { items: itemsDesktop }
        }
      });

      // Add navigation functionality for each slider
      const $nav = $slider.closest(".banner_slider_section").find(".nav_arrow");
      if ($nav.length) {
        const $prevArrow = $nav.find(".s_arrow_left");
        const $nextArrow = $nav.find(".s_arrow_right");

        // Update arrow states
        function updateArrows() {
          setTimeout(function(){
            
              const currentIndex = $slider.find('.owl-item.active').first().index();
              const totalItems = $slider.find('.owl-item').length;
    
              if (currentIndex > 0 || itemLoop) {
                $prevArrow.addClass('active');
                console.log(currentIndex); 
              } else {
                $prevArrow.removeClass('active');
              }
    
              if (currentIndex + $slider.find('.owl-item.active').length < totalItems || itemLoop) {
                $nextArrow.addClass('active');
              } else {
                $nextArrow.removeClass('active');
              }

          }, 100);
        }

        // Initial state
        updateArrows();

        // Listen to events to update arrows
        $slider.on('changed.owl.carousel', function () {
          updateArrows();
        });

        // Navigation click events
        $prevArrow.on("click", function () {
          $slider.trigger("prev.owl.carousel");
        });

        $nextArrow.on("click", function () {
          $slider.trigger("next.owl.carousel");
        });
      }
    });
  }
});

/* new script */

// .nav-buttonの位置を.card__mediaの中央に合わせる
function setNavButtonPosition() {
  // すべての.product-linkに対して処理を実行
  document.querySelectorAll('a.product-link').forEach(link => {
    const cardMedia = link.querySelector('.card__media');
    if (!cardMedia) return;
    
    const mediaRect = cardMedia.getBoundingClientRect();
    const linkRect = link.getBoundingClientRect();
    
    // .card__mediaの中央位置を.product-linkからの相対位置で計算
    const mediaCenterY = mediaRect.top - linkRect.top + mediaRect.height / 2;
    
    // この.product-link内の.navigation-buttonsと.nav-buttonを取得
    const navButtons = link.querySelector('.navigation-buttons');
    const navButtonPrev = link.querySelector('.nav-button.prev');
    const navButtonNext = link.querySelector('.nav-button.next');
    
    if (navButtons) {
      // .navigation-buttonsの高さを.card__mediaに合わせる
      navButtons.style.top = (mediaRect.top - linkRect.top) + 'px';
      navButtons.style.height = mediaRect.height + 'px';
      navButtons.style.bottom = 'auto';
    }
    
    if (navButtonPrev) {
      navButtonPrev.style.top = mediaCenterY + 'px';
      navButtonPrev.style.transform = 'translateY(-50%)';
    }
    
    if (navButtonNext) {
      navButtonNext.style.top = mediaCenterY + 'px';
      navButtonNext.style.transform = 'translateY(-50%)';
    }
  });
}

// 初期実行
setNavButtonPosition();

// リサイズや画像読み込み時に再計算
window.addEventListener('resize', setNavButtonPosition);
document.addEventListener('lazyloaded', setNavButtonPosition);

// 各.product-linkのサイズ変更を監視
const observeProductLinks = () => {
  document.querySelectorAll('a.product-link').forEach(link => {
    const cardMedia = link.querySelector('.card__media');
    if (!cardMedia) return;
    
    // 既に監視されている場合はスキップ
    if (link.hasAttribute('data-position-observed')) return;
    
    const resizeObserver = new ResizeObserver(() => {
      setNavButtonPosition();
    });
    
    resizeObserver.observe(cardMedia);
    resizeObserver.observe(link);
    
    link.setAttribute('data-position-observed', 'true');
  });
};

// DOMContentLoadedとload時に監視を開始
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeProductLinks);
} else {
  observeProductLinks();
}
window.addEventListener('load', observeProductLinks);

// .nav-buttonにクリックイベントを付与
function initializeProductImageBehavior() {
  // すべての製品リンクに対して処理を実行
  document.querySelectorAll('a.product-link').forEach(link => {
    // 既に初期化されている場合はスキップ
    if (link.hasAttribute('data-initialized')) return;
    
    // 画像を取得（両方の構造に対応）
    const images = link.querySelectorAll('.media img, .rv_image_area img');
    if (images.length < 2) return;
    
    const firstImage = images[0];
    const secondImage = images[1];
    
    // 初期状態を設定
    firstImage.style.opacity = '1';
    secondImage.style.opacity = '0';
    let isFirstImageVisible = true;
    
    // ナビゲーションボタンを取得（Liquidで追加済みと想定）
    const prevButton = link.querySelector('.nav-button.prev');
    const nextButton = link.querySelector('.nav-button.next');
    
    if (!prevButton || !nextButton) return;
    
    // active クラスの初期設定
    prevButton.classList.remove('active');
    nextButton.classList.add('active');
    
    // タッチ操作用の変数
    let touchStartX = 0;
    let touchEndX = 0;
    
    // 画像切り替え関数
    const showFirstImage = () => {
      firstImage.style.opacity = '1';
      secondImage.style.opacity = '0';
      isFirstImageVisible = true;
      prevButton.classList.remove('active');
      nextButton.classList.add('active');
    };
    
    const showSecondImage = () => {
      firstImage.style.opacity = '0';
      secondImage.style.opacity = '1';
      isFirstImageVisible = false;
      nextButton.classList.remove('active');
      prevButton.classList.add('active');
      
      // // GAイベントトラッキング
      // const shopifySection = link.closest('.shopify-section');
      // let shopifySectionTitle;

      // // 同じカテゴリのアイテムの場合
      // if (shopifySection.querySelector('.page-width.section-category-product__container')) {
      //   shopifySectionTitle = "同じカテゴリのアイテム";
      // }
      // // 同じ出品者のアイテムの場合
      // else if (shopifySection.querySelector('.page-width.section-picker-product__container')) {
      //   shopifySectionTitle = "同じ出品者のアイテム";
      // }
      // // それ以外の場合
      // else {
      //   const headerTitle = shopifySection.querySelector('h2.section-header__title');
      //   shopifySectionTitle = headerTitle ? headerTitle.textContent.trim() : "不明なセクション";
      // }

      // window.dataLayer = window.dataLayer || [];
      // dataLayer.push({
      //   'event': 'second_img_impression',
      //   'second_img_impression_category': shopifySectionTitle
      // });
    };
    
    // ボタンクリックハンドラー
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      showSecondImage();
      return false; // リンクのナビゲーションを防止
    });
    
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      showFirstImage();
      return false; // リンクのナビゲーションを防止
    });
    
    // タッチイベントハンドラー
    link.addEventListener('touchstart', (e) => {

      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    
    link.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].clientX;
      const swipeDistance = touchEndX - touchStartX;
      
      if (Math.abs(swipeDistance) > 50) {
        if (swipeDistance > 0 && !isFirstImageVisible) {
          showFirstImage();
        } else if (swipeDistance < 0 && isFirstImageVisible) {
          showSecondImage();
        }
      }
    }, { passive: true });
    
    // 初期化済みとマーク
    link.setAttribute('data-initialized', 'true');
  });
  
  // 画像初期化後に位置を再計算
  setNavButtonPosition();
}



const observeForProductGrid = () => {
  // 製品コンテナの要素を取得
  const productGridContainer = document.querySelector('.product-grid-container');
  
  // 製品コンテナが存在しない場合は処理を終了
  if (!productGridContainer) {
    return;
  }
  
  const observer = new MutationObserver(() => {
    // 最初の製品リンクを探す
    const firstProductLink = document.querySelector('.product-link');
    
    // リンクが存在するが、初期化されていない場合に初期化を実行
    if (firstProductLink && !firstProductLink.hasAttribute('data-initialized')) {
      initializeProductImageBehavior();
      // 位置も再計算
      setTimeout(setNavButtonPosition, 100);
    }
  });
  
  // 製品コンテナが存在する場合のみ監視を開始
  observer.observe(productGridContainer, {
    childList: true,
    subtree: true
  });
};

const observeForRecentViewed = () => {
  // 監視対象を最初に定義し、存在チェックを行う
  const targetElement = document.querySelector('#pickyou-recently-viewed-products-area');
  if (!targetElement) {
    return; // 要素がない場合は処理を終了
  }

  const observer = new MutationObserver(() => {
    const uninitializedLinks = document.querySelectorAll('#pickyou-recently-viewed-products .product-link:not([data-initialized])');
    
    if (uninitializedLinks.length > 0) {

      
      const initializeInterval = setInterval(() => {
        initializeProductImageBehavior();
        setNavButtonPosition();
        
        const remainingLinks = document.querySelectorAll('#pickyou-recently-viewed-products .product-link:not([data-initialized])');
        if (remainingLinks.length === 0) {
          clearInterval(initializeInterval);
        }
      }, 1000);
    }
  });

  // 存在確認済みの要素を監視開始
  observer.observe(targetElement, {
    childList: true,
    subtree: true
  });

};

// 初期セットアップ
initializeProductImageBehavior();
observeForRecentViewed();
observeForProductGrid();

const displayPointInfo = (pointValue) => {
  const loginAlertStyle = userProps.user_id !== null ? ' style="display: none;"' : '';
  const newContentPoint = `
    <div class="optx-mrpoint-productaward-point-value">
      <span class="optx-point-value">${pointValue}</span>
      <span class="optx-point-string">pt</span>
      <span class="optx-point-striing">獲得</span>
    </div>
    `
  const newContentPaidy = `<div class="optx-mrpoint-login-alert"${loginAlertStyle}>
      <div style="display: flex; align-items: start; gap: 4px;">
        <div style="width: 16px; height: 18px;">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.00004 11.334C8.18893 11.334 8.34726 11.2701 8.47504 11.1423C8.60282 11.0145 8.66671 10.8562 8.66671 10.6673C8.66671 10.4784 8.60282 10.3201 8.47504 10.1923C8.34726 10.0645 8.18893 10.0007 8.00004 10.0007C7.81115 10.0007 7.65282 10.0645 7.52504 10.1923C7.39726 10.3201 7.33337 10.4784 7.33337 10.6673C7.33337 10.8562 7.39726 11.0145 7.52504 11.1423C7.65282 11.2701 7.81115 11.334 8.00004 11.334ZM7.33337 8.66732H8.66671V4.66732H7.33337V8.66732ZM8.00004 14.6673C7.07782 14.6673 6.21115 14.4923 5.40004 14.1423C4.58893 13.7923 3.88337 13.3173 3.28337 12.7173C2.68337 12.1173 2.20837 11.4118 1.85837 10.6007C1.50837 9.78954 1.33337 8.92287 1.33337 8.00065C1.33337 7.07843 1.50837 6.21176 1.85837 5.40065C2.20837 4.58954 2.68337 3.88398 3.28337 3.28398C3.88337 2.68398 4.58893 2.20898 5.40004 1.85898C6.21115 1.50898 7.07782 1.33398 8.00004 1.33398C8.92226 1.33398 9.78893 1.50898 10.6 1.85898C11.4112 2.20898 12.1167 2.68398 12.7167 3.28398C13.3167 3.88398 13.7917 4.58954 14.1417 5.40065C14.4917 6.21176 14.6667 7.07843 14.6667 8.00065C14.6667 8.92287 14.4917 9.78954 14.1417 10.6007C13.7917 11.4118 13.3167 12.1173 12.7167 12.7173C12.1167 13.3173 11.4112 13.7923 10.6 14.1423C9.78893 14.4923 8.92226 14.6673 8.00004 14.6673Z" fill="#717171"/>
          </svg>
        </div>
        <div style="color: #717171;">
          ポイントを獲得するためには<a style="color: rgba(28, 146, 242, 1) !important;" href="/account/login">ログイン</a>または<a style="color: rgba(28, 146, 242, 1) !important;" href="/account/register">アカウントを作成</a>してください
        </div>
      </div>
    </div>
    <style>
      .mrpoint-product__award-point {
        display: none;
      }
      product-info > div[role="status"], 
      product-info .price__container, 
      .optx-mrpoint-productaward-point-value {
        margin-bottom: 0!important;
      }
      .optx-mrpoint-productaward-point-value {
        margin-top: 16px!important;
        font-weight: bold;
      }
      .optx-point-value {
        font-size: 18px;
        color: #ed293e;
      }
      .optx-point-striing {
        font-size: 12px;
      }
      .optx-mrpoint-login-alert {
        font-size: 12px;
        padding-top: 0;
        margin-top: 0;
      }
      .optx-mrpoint-login-alert a,
      .optx-mrpoint-login-alert a:visited {
        color: #000000!important;
        font-weight: bold;
        text-decoration: underline;
      }
      .optx-mrpoint-login-alert > img {
        width: 12px;
        height: 12px;
        margin-top: -5px!important;
      }
      #app-embed-container-231467 {
        display: none!important;
      }
    </style>
  `;
  // ポイント表示の挿入
  const targetElementPoint = document.querySelector('.product__info-container [role="status"]');
  if (targetElementPoint) {
    targetElementPoint.insertAdjacentHTML('afterend', newContentPoint);

    const applyPointStyles = () => {
      const pointNodes = document.querySelectorAll('.optx-mrpoint-productaward-point-value');
      if (!pointNodes.length) return;
      const isPointUpApplied = document.querySelector('.price.price--point-up') !== null;
      const margin = isPointUpApplied ? '22px' : '16px';
      const paddingTop = isPointUpApplied ? '18px' : '10px';
      const fontSize = isPointUpApplied ? '20px' : '14px';

      pointNodes.forEach((el) => {
        el.style.setProperty('margin-top', margin, 'important');
        el.style.setProperty('padding-top', paddingTop, 'important');
        const valueNode = el.querySelector('.optx-point-value');
        if (valueNode) {
          valueNode.style.setProperty('font-size', fontSize, 'important');
        }
      });
    };

    applyPointStyles();

    const priceNode = document.querySelector('.product__info-container .price');
    if (priceNode) {
      const priceClassObserver = new MutationObserver(() => applyPointStyles());
      priceClassObserver.observe(priceNode, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // Paidy表示の挿入
  const targetElementPaidy = document.querySelector('.icon-with-text');
  if (targetElementPaidy) {
    targetElementPaidy.insertAdjacentHTML('beforebegin', newContentPaidy);
  }
};
const pointElement = document.querySelector('.mrpoint-product__award-point-value.js-award-point-value');
if (pointElement) {
  // テキストが既に存在する場合
  if (pointElement.textContent.trim()) {
    displayPointInfo(pointElement.textContent);
  }
  
  // テキストの変更を監視
  const observer = new MutationObserver((mutations, obs) => {
    mutations.forEach(mutation => {
      if (mutation.type === 'characterData' || mutation.type === 'childList') {
        const updatedText = pointElement.textContent.trim();
        if (updatedText) {
          obs.disconnect();
          displayPointInfo(updatedText);
        }
      }
    });
  });
  // テキストノードと子要素の両方を監視
  observer.observe(pointElement, {
    characterData: true,
    childList: true,
    subtree: true
  });
}
// NEW END 


window.addEventListener('load', () => {
	setTimeout(() => {
      $('.biggo-relative-product-list .item-price').each(function() {
          const text = $(this).text();
          $(this).text(text.replace('￥', '¥'));
      });
    }, 1000);
});

// iOS 18.4.1より古いバージョンを検出し、特定のCSSを追加する関数
function addCSSForOlderIOS() {
  // iOSデバイスかどうかをチェック
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  
  // iOS以外の場合は何もしない
  if (!isIOS) return;
  
  // iOSバージョンを抽出
  let match = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
  if (!match) return;
  
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3] || 0, 10);
  
  // iOS 18.4.1より古いバージョンかチェック
  if (major < 18 || (major === 18 && (minor < 4 || (minor === 4 && patch < 1)))) {
    // スタイル要素を作成
    const style = document.createElement('style');
    
    // 要求されたCSSプロパティを追加
    style.textContent = `
      .product-link .nav-button svg,
      .multi_collection .nav-button svg,
      .product-grid .nav-button svg {
        transform: scale(2.5);
      }
    `;
    
    // スタイルをドキュメントのヘッドに追加
    document.head.appendChild(style);
    console.log('古いiOSバージョン用のCSSを適用しました');
  }
}

// DOMの読み込み完了時に実行
document.addEventListener('DOMContentLoaded', addCSSForOlderIOS);
